export enum AuthenticatedUserType {
  Anonymous = 0,
  Authenticated = 100,
}
